import { QRCodeCanvas } from "qrcode.react";
import clsx from "classnames";
import { TypographyVariant } from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { Icon } from "../../core/Icon/Icon";
import { MAX_WIDTH_MOBILE } from "../../../constants/dimension";
import { TypePopup } from "../../../types/popup";
import { getSetupDevicesTitle } from "../../../models/media";
import { useStyles } from "./SetupDevicesPopup.style";

type ISetupDevicesPopupProps = {
  type: TypePopup;
};

export const SetupDevicesPopup: React.FC<ISetupDevicesPopupProps> = (props) => {
  const { type } = props;
  const classes = useStyles();
  const isMobile = window.innerWidth <= MAX_WIDTH_MOBILE;

  const getInstallText = () => {
    if (type === "ios") {
      return (
        <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
          2. Tap the{" "}
          <Typography variant={TypographyVariant.BodyB3Bold} inline>
            Share
          </Typography>{" "}
          button on the toolbar
        </Typography>
      );
    }
    if (type === "osx") {
      return (
        <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
          2. Select{" "}
          <Typography variant={TypographyVariant.BodyB3Bold} inline>
            Add to Dock
          </Typography>{" "}
          or{" "}
          <Typography variant={TypographyVariant.BodyB3Bold} inline>
            Install
          </Typography>{" "}
          on the toolbar
        </Typography>
      );
    }
    return (
      <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
        2. Click button{" "}
        <Typography variant={TypographyVariant.BodyB3Bold} inline>
          Install Now
        </Typography>
      </Typography>
    );
  };

  return (
    <>
      <div className={classes.header}>
        <Typography
          variant={
            isMobile
              ? TypographyVariant.BodyB2Bold
              : TypographyVariant.HeadingH3Bold
          }
        >
          {getSetupDevicesTitle(type)}
        </Typography>
      </div>
      <div className={classes.container}>
        <div className={classes.item}>
          <div className={classes.qrInner}>
            <QRCodeCanvas
              value={import.meta.env.VITE_APP_URL}
              bgColor="#FFFFFF"
              fgColor="#000000"
              level="L"
              className={classes.qrCode}
            />
          </div>
          <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
            1. Scan QR code or open{" "}
            <Typography
              variant={TypographyVariant.BodyB3Medium}
              inline
              className={classes.link}
            >
              {import.meta.env.VITE_APP_URL.replace(/^https?:\/\//, "")}
            </Typography>
            {type === "ios" && " in Safari"}
          </Typography>
        </div>
        <div className={classes.item}>
          <Icon
            name={type === "ios" ? "icon-logout" : "icon-linear-add-square"}
            size={!isMobile ? 50 : 30}
            className={clsx(classes.icon, { ios: type === "ios" })}
          />
          {getInstallText()}
        </div>
        <div className={classes.item}>
          <Icon
            name={
              type === "ios"
                ? "icon-linear-add-square"
                : "icon-linear-tick-circle"
            }
            size={!isMobile ? 50 : 30}
            className={classes.icon}
          />
          <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
            3. {type !== "ios" && "Accept system prompt"}
            {type === "ios" && (
              <>
                Swipe up and select{" "}
                <Typography variant={TypographyVariant.BodyB3Bold} inline>
                  Add to Home Screen
                </Typography>{" "}
                from the menu
              </>
            )}
          </Typography>
        </div>
        <div className={classes.item}>
          <Icon
            name="icon-tick"
            size={!isMobile ? 50 : 30}
            className={classes.icon}
          />
          <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
            4. Open ONMO+ from your{" "}
            {type === "android" || type === "ios" ? "home screen" : "desktop"}
          </Typography>
        </div>
      </div>
    </>
  );
};
